/*----------------------
   HOME PRODUCTS
---------------------- */
HomeProducts = {
    init: function () {
        $(".swiper--home-products").each(function () {
            if (this.swiper) {
                this.swiper.update();
                return;
            }

            new Swiper(this, {
                slidesPerView: "auto",
                slidesPerGroup: 1,
                spaceBetween: 12,
                pagination: {
                    el: $(this).siblings(".home-products__header").find(".home-products__pagination")[0],
                    clickable: true
                },
                mousewheel: {
                    invert: false,
                    forceToAxis: true,
                    thresholdDelta: 20,
                    thresholdTime: 600
                },
                freeMode: {
                    enabled: false,
                    sticky: false,
                    momentumBounce: false

                },
                breakpoints: {
                    0: {
                        spaceBetween: 16,
                        freeMode: {
                            enabled: false
                        }
                    },
                    769: {
                        spaceBetween: 12,
                        freeMode: {
                            enabled: true,
                            sticky: false,
                            momentumBounce: false
                        }
                    }
                }
            });
        });

        $("[data-home-product-add]").off("click.homeProducts").on("click.homeProducts", function (e) {
            e.preventDefault();

            const button = $(this);
            const productID = button.attr("data-id");
            if (!productID || button.hasClass("product-adding")) return;

            const buttonLabel = button.find(".js-home-product-add-label");
            const originalButtonLabel = buttonLabel.text();
            const addingButtonLabel = button.attr("data-adding-text");

            button.addClass("product-adding");
            button.attr("aria-busy", "true");
            if (buttonLabel.length && addingButtonLabel) {
                buttonLabel.text(addingButtonLabel);
            }

            $.post(
                window.Shopify.routes.root + "cart/add.js",
                { items: [{ id: Number(productID), quantity: 1 }], sections: "section-cart-notification" },
                null,
                "json"
            )
                .done(function (data) {
                    const cartEl = $(".cart-notification__products");
                    if (cartEl.length && data.sections && data.sections["section-cart-notification"]) {
                        cartEl.empty();
                        cartEl.append($(data.sections["section-cart-notification"]).html());
                    }

                    if (window.CartNotification && typeof CartNotification.refresh === "function") {
                        CartNotification.refresh();
                    }

                    $(".cart-notification").addClass("cart-notification-active");
                    $("body").addClass("cart-notification-open");
                })
                .fail(function (data) {
                    if (data.responseJSON && data.responseJSON.description) {
                        alert(data.responseJSON.description);
                    }
                })
                .always(function () {
                    button.removeClass("product-adding");
                    button.removeAttr("aria-busy");
                    if (buttonLabel.length) {
                        buttonLabel.text(originalButtonLabel);
                    }
                });
        });
    }
};

$(document).ready(function () {
    HomeProducts.init();
});

$(document).on("shopify:section:load", function () {
    HomeProducts.init();
});
